/**
 * Idempotent: ensures window.__leSafeStorage exists before Vue / inline head scripts that may run earlier via mix.
 */
import './safe-storage-global';

/**
 * Load dependencies
 */

import Vue from 'vue';

// Import setup module to configure
import setup from './setup';

// Import bootstrap-vue components
import bootstrap from './bootstrap-setup.js';

/**
 * Register global vue components so they may be used in blade templates
 * Example: @component/ExampleComponent.vue -> <example-component></example-component>
 */
Vue.component('header-nav', 				() => import('@component/Header.vue'));
Vue.component('breadcrumb', 				() => import('@component/Breadcrumb.vue'));
Vue.component('offer-details-card', 		() => import('@component/OfferDetailsCard.vue'));
Vue.component('product-display', 			() => import('@component/ProductDisplay.vue'));
Vue.component('related-offers', 			() => import('@component/RelatedOffers.vue'));
Vue.component('downsell-option', 			() => import('@component/DownsellOption.vue'));
Vue.component('upsell-option', 				() => import('@component/UpsellOption.vue'));
Vue.component('upsell-multiple', 			() => import('@component/UpsellMultiple.vue'));
Vue.component('featured-offers', 			() => import('@component/FeaturedOffers.vue'));
Vue.component('offer-options', 				() => import('@component/OfferOptions.vue'));
Vue.component('receipt', 					() => import('@component/Receipt.vue'));
Vue.component('jw-video', 					() => import('@component/JWVideo.vue'));
Vue.component('sms-modal', 					() => import('@component/SMSModal.vue'));
Vue.component('shipping-modal', 			() => import('@component/ShippingAddressModal.vue'));
Vue.component('ccpa-notification', 			() => import('@component/CCPANotification.vue'));
Vue.component('checkout-v3', 				() => import('@component/user-backend/Checkout/V3/Checkout.vue'));
Vue.component('checkout-v4', 				() => import('@component/user-backend/Checkout/V4/Checkout.vue'));
Vue.component('checkout-vs',          		() => import('@component/user-backend/Checkout/VS/Checkout.vue'));

import store from '@js/store';

/**
 * Create a Vue application instance
 */

import sharedSetup from '@js/vue-setup.js';
Vue.use(sharedSetup);

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

import CheckoutErrorHandler from './plugins/CheckoutErrorHandler';
Vue.use(CheckoutErrorHandler);

new Vue({
	el: (typeof altAppSelector === 'undefined' || !altAppSelector) ? '#app' : altAppSelector,
	store
});
